export enum NoteTypeModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
